/* eslint-disable prefer-destructuring */
/**

Coded by www.techhighway.ca

*/

// @mui material components
import Dialog from "@mui/material/Dialog";
import { styled } from "@mui/material/styles";

export default styled(Dialog)(({ theme }) => {
  const { palette, functions } = theme;

  return {
    ".MuiDialogTitle-root": {
      textAlign: "center",
    },
  };
});
